import { Commit } from 'vuex'

export default {
  clearVuexPersistState({ commit }: { commit: Commit }, mutationName: string) {
    if (mutationName) {
      commit(mutationName)
    }
  }
}
